import { useState } from "react";
import { useForm } from "react-hook-form";

//api
import { KBService } from "../../../../service/kb-service";

//components
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { FileUpload } from "primereact/fileupload";
import { Button } from "primereact/button";

const AddKBFile = ({onKBFileCreated})=>{
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [uploadSuccessMessage, setUploadSuccessMessage] = useState('');
    const [uploadErrorMessage, setUploadErrorMessage] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const status = [
        {name: 'active'},
        {name: 'archived'}
    ]

    const onFileChange = (event) => {
        if (event.files && event.files.length > 0) {
            setSelectedFile(event.files[0]);
            setUploadSuccessMessage(''); 
            setUploadErrorMessage('');
        } else {
            setSelectedFile(null);
        }
    };

    const onSubmit = (data)=>{
            if (!selectedFile) {
                console.error('Nessun file selezionato.');
                return;
            }
            
            const formData = new FormData();
            formData.append('title', data.title);
            formData.append('description', data.description);
            formData.append('file', selectedFile);
            formData.append('status', selectedStatus?.name || '')
    
            KBService.addKBFile(
                formData,
                (response)=>{
                    setUploadSuccessMessage('File aggiunto con successo!', response);
                    setUploadErrorMessage('');
                    // reset campi dopo caricamento file
                    setSelectedFile(null)
                    setValue('title', '');
                    setValue('description', '');
                    setValue('status', null);
                    onKBFileCreated()
                },
                (error) => {
                    console.error('Errore durante la creazione del file: ', error);
                    setUploadErrorMessage('Errore durante la creazione del file.');
                    setUploadSuccessMessage('');
                  }
            )
        }

    return (
            <div style={{marginBottom:'2rem', marginRight:'2rem'}}>
                <form onSubmit={handleSubmit(onSubmit)}>
                {uploadSuccessMessage && <div className="p-message p-message-success" style={{ padding: '0.5em' }}>{uploadSuccessMessage}</div>}
                {uploadErrorMessage && <div className="p-message p-message-error" style={{ padding: '0.5em' }}>{uploadErrorMessage}</div>}
                    <div className="p-field addAnalysisFile__InputWrapper">
                        <label htmlFor="name">Titolo*</label>
                        <InputText id="name" {...register('title', { required: 'Campo obbligatorio' })} className={errors.name ? 'p-invalid' : ''} />
                        {errors.name && <small className="p-error">{errors.name.message}</small>}
                    </div>
                    <div className="template__DropdownWrapper" style={{justifyContent: "space-between"}}>
                        <div className="card template__DropdownInput" style={{width: '15rem'}}>
                            <label htmlFor="name" >Stato*</label>
                                <Dropdown value={selectedStatus} onChange={(e) => setSelectedStatus(e.value)} options={status} optionLabel="name" 
                                    placeholder="Seleziona uno Status" className="w-full md:w-14rem" style={{margin:'0.5rem 0'}}/>
                        </div>

                    </div>
                    <div className="p-field addAnalysisFile__InputWrapper">
                        <label htmlFor="description">Descrizione*</label>
                        <InputTextarea id="description" {...register('description')} rows={3} cols={30} />
                    </div>
    
                    <div className="p-field ">
                        <label htmlFor="file">Upload File*</label>
                        <FileUpload
                            id="file"
                            name="file"
                            maxFileSize={1000000}
                            onSelect={onFileChange}
                            mode="basic"
                            chooseLabel="Scegli File"
                            accept=".md,.pdf,.txt,.jpeg,.jpg,.png"
                            style={{marginTop:'0.5rem'}}
                        />
                        {selectedFile && <small>File selezionato: {selectedFile.name}</small>}
                        {selectedFile === null && <small className="p-error">Seleziona una file</small>}
                    </div>
                    <Button label="Aggiungi" type="submit" disabled={!selectedFile || Object.keys(errors).length > 0} style={{marginTop:'1rem'}}/>
                </form>
            </div>
        );
}

export default AddKBFile